import React from 'react';
import { observer } from 'mobx-react';

import { RootStoreContext } from '../../../../../../context';


export default (Component) => {
  @observer
  class withStoreMessages extends React.Component {

    static contextType = RootStoreContext;

    render() {
      return (
        <Component
          loadMessages={this.context.privateMessagingStore.loadConversationSessionMessages}
          loadPreviousMessages={this.context.privateMessagingStore.loadPreviousConversationSessionMessages}
          loadingPreviousMessages={this.context.privateMessagingStore.loadingOldMessages}
          messages={this.context.privateMessagingStore.messages}
          reachedEndOfMessageHistory={this.context.privateMessagingStore.reachedEndOfMessageHistory}
          seenTimestamp={this.context.privateMessagingStore.seenTimestamp}
          {...this.props}
          inputAreaHeight={this.context.privateMessagingStore.inputAreaHeight}
        />
      );
    }
  }

  return withStoreMessages;
};
